
export const environment = {
    uploadImageUrl: 'https://europe-west1-tdglobal-dev.cloudfunctions.net/fileStorageApi/upload/public?subDomain=gowaterfall',
    uploadImageApiKey: 'DYnyC9gqx46j8rjZ0zophhk0in2Q9C2M',
    issueCollection: 'Issues',
    settingsCollection: 'settings',
    loggedIssuesCollection: '/Issues/loggedIssues/list/',
    host: 'https://redefine-help-portal.firebaseapp.com/Issue/',
    elasticApiKey: '45be9f24-7559-437d-b8d1-35cd1b6a0725',
    elsaticHost: 'https://api.elasticemail.com/',
    elsaticVersion: 'v2',
    userIssueEmailTemplate: 'Redefine_User_IssueSubmission',
    userFromEmail: 'support@thinkdigital.co.za',
    userToEmail: 'support@thinkdigital.co.za',
    userReplyToEmail: 'support@thinkdigital.co.za',
    userIssueEmailSubject: 'A new issue has been logged by a user on the Redefine app',
    adminIssueEmailTemplate: 'Redefine_Escalate_Issue',
    adminFromEmail: 'support@thinkdigital.co.za',
    adminToEmail: 'support@thinkdigital.co.za',
    adminReplyToEmail: 'support@thinkdigital.co.za',
    adminIssueEmailSubject: 'An issue has been escalated for assistance',
    faqCollection: 'Issues/faqs/list'
}